export default __webpack_public_path__ + "static/media/environmentalImpact.0360043e.svg";